import React from 'react';
import {Boton} from '../comun/Index'
import { TextField } from '@mui/material';
import Nueva from '../personas/Nueva';
import Persona from './Persona';
import axios from 'axios';



const getPersonas = function(busqueda){
  return new Promise((resolve, reject) => {
    const url = localStorage.getItem('apiUrl') + '/personas/todos/';
    const config = {
      headers:{authorization:sessionStorage.getItem('token')},
      params:{busqueda}
    };
    axios.get(url, config)
    .then((res) => resolve(res.data.personas))
    .catch((error) => reject(error));
  })
}

const generarArrayPersonas = function(personas, personasSelec){
  personas = personas.filter((item, index) => {
    const pos = personasSelec.findIndex((item2) => item.id === item2.id);
    return(pos === -1);
  })
  personasSelec.push(...personas);
  return(personasSelec);
}

export default class Personas extends React.Component{
  constructor(props){
    super(props);
    this.state={
      busqueda:"",
      showNuevaPersona:false,
      personas:[],
      personasSelec:[]
    }
  }

  busqueda(valor, personasSelec = null){
    if (valor.length >= 3) {
      getPersonas(valor)
      .then((personas) => {
        let personasSelec = JSON.parse(JSON.stringify(this.props.datos.personasSelec));
        this.setState({personas:generarArrayPersonas(personas, personasSelec)});
      })
      .catch((error) => {
        console.log(error);
        alert("Ocurrió un error");
      })
    } else {
      if (personasSelec === null) personasSelec = JSON.parse(JSON.stringify(this.props.datos.personasSelec));
      this.setState({personas:generarArrayPersonas([], personasSelec)});
    }
    this.setState({busqueda:valor});
  }

  seleccionar(persona){
    let personasSelec = JSON.parse(JSON.stringify(this.props.datos.personasSelec));
    const pos = personasSelec.findIndex((item) => item.id === persona.id);
    if (pos === -1 ) {
      personasSelec.push(persona);
    } else {
      personasSelec.splice(pos, 1);
    }
    this.props.editar('personasSelec',personasSelec);
    this.setState({personasSelec: personasSelec.map((item) => item.id)});
    this.busqueda('', personasSelec); 
  }
  
  personaGuardada(persona){
    this.setState({showNuevaPersona:false})
  }

  render(){
    const {busqueda, showNuevaPersona, personas, personasSelec} = this.state;
    const {localidades} = this.props;
    return(
      <div style={{width:'100%', borderRadius:10, padding:10, margin:10, display:'flex', flexDirection:'column', alignItems:'center'}}>
        {showNuevaPersona &&
          <Nueva
            guardado={(persona) => this.personaGuardada(persona)}
            localidades={localidades}
            salir={() => this.setState({showNuevaPersona:false})}
          />
        }
        <div style={{display:'flex', flexDirection:'row', alignItems:'center',justifyContent:'center'}}>
          <TextField
            size="small"
            style={{textAlign:'center',minWidth:0,margin:'5px 1px'}}
            sx={{backgroundColor:'white', borderRadius:1}}
            label="Busqueda"
            value={busqueda}
            placeholder='DNI, apellidos, nombres...'
            onChange={(e) => this.busqueda(e.target.value)}
            variant="outlined"
          />
          <span style={{marginTop:-3}}>
            <Boton
              backgroundColor="#00A6E5"
              titulo="Nueva persona"
              size={22}
              onClick={() => this.setState({showNuevaPersona:true})}
            />
          </span>
        </div>
        <div style={{display:'flex', flexDirection:'row', width:'100%', flexWrap:'wrap', justifyContent:'center'}}>
          {personas?.length === 0 &&
            <span>Sin resultados</span>
          }
          {personas?.length > 0 &&
            personas.map((persona, index) => {
              return(
                <Persona
                  key={persona.id}
                  datos={persona}
                  seleccionado={personasSelec.includes(persona.id)}
                  seleccionar={() => this.seleccionar(persona)}
                />
              )
            })
          }
        </div>
      </div>
    )
  }
}